import React from "react";
import { Card, Row, Col, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { useScanQrcodeStore } from "@/store";

interface CustomerProfileProps {
  className?: string;
}

const CustomerProfile: React.FC<CustomerProfileProps> = ({ className = "" }) => {
  const { t } = useTranslation();
  const { customer, stamp_code, verification_location } = useScanQrcodeStore();

  if (customer.length === 0) {
    // Nếu customer là mảng rỗng thì tức là tem chưa được xác thực => không hiển thị thông tin khách hàng
    return null;
  }

  return (
    <Card
      className={className}
      title={t("common.verification_info")}
      styles={{ title: { color: "var(--color-warning)", fontWeight: 600 } }}
    >
      <Row gutter={[16, 16]}>
        {customer?.name && (
          <Col span={24}>
            <div className="flex justify-between items-center">
              <span className="font-medium">{t("form.full_name")}:</span>
              <span className="col-span-7 text-right qrx-text--default font-semibold">{customer.name}</span>
            </div>
          </Col>
        )}

        {customer?.phone && (
          <Col span={24}>
            <div className="flex justify-between items-center">
              <span className="font-medium">{t("form.phone_number")}:</span>
              <span className="col-span-7 text-right qrx-text--default font-semibold">{customer.phone}</span>
            </div>
          </Col>
        )}

        {stamp_code?.first_verification_at && (
          <Col span={24}>
            <div className="flex justify-between items-center">
              <span className="font-medium">{t("common.verification_date")}:</span>
              <span className="col-span-7 text-right qrx-text--default font-semibold">
                {stamp_code?.first_verification_at || ""}
              </span>
            </div>
          </Col>
        )}

        {stamp_code?.has_warranty && stamp_code?.stamp_has_warranty && (
          <Col span={24}>
            <div className="flex justify-between items-center">
              <span className="font-medium">{t("common.warranty_period")}:</span>
              <span className="col-span-7 text-right qrx-text--default font-semibold">
                {stamp_code?.warranty_starts_at} - {stamp_code?.warranty_ends_at}
              </span>
            </div>
          </Col>
        )}

        {stamp_code?.warranty_days_left != null && (
          <Col span={24}>
            <div className="flex justify-between items-center">
              <span className="font-medium">{t("common.remaining_days")}:</span>
              <span className="col-span-7 text-right qrx-text--success font-semibold">
                {stamp_code.warranty_days_left} {t("common.days")}
              </span>
            </div>
          </Col>
        )}

        {stamp_code?.is_warranty_replaced && (
          <Col span={24}>
            <div className="flex justify-between items-center">
              <span className="font-medium">{t("common.status")}:</span>
              <span className="col-span-7 text-right">
                <Tag color="warning" className="!mr-0">
                  {t("common.warranty_replaced")}
                </Tag>
              </span>
            </div>
          </Col>
        )}

        {verification_location?.full_address && (
          <Col span={24}>
            <div className="flex justify-between items-center">
              <span className="font-medium">{t("common.verified_localtion")}:</span>
              <span className="col-span-7 text-right qrx-text--default font-semibold">
                {verification_location?.full_address}
              </span>
            </div>
          </Col>
        )}
      </Row>
    </Card>
  );
};

export default CustomerProfile;
